import React from 'react';
import { observer } from 'mobx-react-lite';
import { formatDateLabel } from '@/shared/utils/formatDateLabel';
import dayjs from '@/shared/lib/dayjs';
import { useStore } from '@/app/providers/StoreProvider';
import { useNavigate } from 'react-router-dom';
import NoTeam from '@/shared/pictures/no_team.png';


export const UpcomingMatch = observer(() => {
    const navigation = useNavigate();
    const { forecastStore } = useStore();

    if(forecastStore.getWithoutActualMatch().length == 0) return null;
  return (
    <div className="forecast-upcoming">
        <h2 className='forecast-upcoming_title'>Ближайшие матчи:</h2>
        <div className="forecast-upcoming_items">
            {forecastStore.getWithoutActualMatch().map((match)=>(
                <div className="forecast-upcoming_item" onClick={()=>navigation(`/forecast-set?id=${match.id}`)} key={match.id}>
                    <div className="forecast-upcoming_teams">
                        <div className="forecast-upcoming_team">
                            <img className="forecast-upcoming_team__icon" src={match.home.logo} alt="icon" 
                              onError={(e) => {
                                e.currentTarget.onerror = null;
                                e.currentTarget.src = NoTeam;
                             }}
                             />
                            <p className="forecast-upcoming_team__text">{match.home.name}</p>
                        </div>
                        <div className="forecast-upcoming_team">
                            <img className="forecast-upcoming_team__icon" src={match.away.logo} alt="icon" 
                              onError={(e) => {
                                e.currentTarget.onerror = null;
                                e.currentTarget.src = NoTeam;
                             }}
                             />
                            <p className="forecast-upcoming_team__text">{match.away.name}</p>
                        </div>
                    </div>
                    <div className="forecast-upcoming_date">
                        {formatDateLabel(dayjs(match.date)).title}
                        <span>
                          {formatDateLabel(dayjs(match.date)).date}
                        </span>
                    </div>
                </div>
            ))}
        </div>
    </div>  
  );


});